import { Helmet } from 'react-helmet-async';
import { Navigate, useParams } from 'react-router';

import { hasPermission } from 'src/utils/has-permissions';

import { useAuthContext } from 'src/auth/hooks';
import { AuthPermissions } from 'src/auth/permissions';

import StationeryItemDetailView from 'src/sections/stationery-item/view/stationery-item-detail-view';

export default function StationeryItemDetailPage() {
  const { user: authUser } = useAuthContext();

  const params = useParams();

  const { id } = params;

  return (
    <>
      <Helmet>
        <title> Stationery item details</title>
      </Helmet>

      {hasPermission(
        authUser,
        'any',
        AuthPermissions.READ_STATIONERY_ITEM,
        AuthPermissions.ADMIN_PERMISSION,
        AuthPermissions.SUPER_ADMIN_PERMISSION
      ) ? (
        <StationeryItemDetailView id={`${id}`} />
      ) : (
        <Navigate to="/403" />
      )}
    </>
  );
}
